export class SoundConfig {
    static readonly START_GAME_AMBIANCE_CROSS_FADE_DURATION: number = 0;

    static readonly FS_GAME_AMBIANCE: string = 'background-music-fs';
    static readonly FS_TOTAL_WIN: string = 'fsEnds';
    static readonly FS_INTRO: string = 'fsIntro';
    static readonly FS_OUTRO_LOOP: string = 'fsOutroLoop';
    static readonly FS_OUTRO_LOOP_BUTTERFLY: string = 'fsOutroLoopButterfly';
    static readonly FS_OUTRO_LOOP_SKULL: string = 'fsOutroLoopSkull';
    static readonly FS_OUTRO_LOOP_BUTTERFLY_HIGHLIGHT: string = 'fsOutroHighlightButterfly';
    static readonly FS_OUTRO_LOOP_SKULL_HIGHLIGHT: string = 'fsOutroHighlightSkull';
    static readonly FS_OUTRO_SELECT_BUTTERFLY: string = 'fsOutroSelectButterfly';
    static readonly FS_OUTRO_SELECT_SKULL: string = 'fsOutroSelectSkull';
    static readonly FS_OUTRO_END_GOOD: string = 'fsOutroEndsGood';
    static readonly FS_OUTRO_END_BAD: string = 'fsOutroEndsBad';
    static readonly FS_START: string = 'fsStart';
    static readonly FS_INTRO_START: string = 'fsIntroStart';
    static readonly FS_OUTRO_QUIT: string = 'fsOutroQuit';

    static readonly LVL_METER_UP_25: string = 'lvlMeterUp25';
    static readonly LVL_METER_UP_50: string = 'lvlMeterUp50';
    static readonly LVL_METER_UP_75: string = 'lvlMeterUp75';
    static readonly LVL_METER_UP_99: string = 'lvlMeterUp99';
    static readonly LVL_METER_COUNTER: string = 'lvlMeterCounter';
    static readonly LVL_START_5_BUY: string = 'lvlStart5Buy';
    static readonly LVL_5: string = 'lvl5';
    static readonly LVL_END: string = 'lvlEnd';

    static readonly SOUL_WOOSH: string[] = ['soulWoosh01', 'soulWoosh02', 'soulWoosh03'];
    static readonly WILD_HIGHLIGHT: string[] = ['wildHighlight01', 'wildHighlight02', 'wildHighlight03'];

    static readonly WILD_HIGHLIGHT_SMALL: string[] = ['winHiglightSmall01', 'winHiglightSmall02', 'winHiglightSmall03'];
    static readonly WILD_HIGHLIGHT_BIG: string[] = ['winHiglightBig01', 'winHiglightBig02', 'winHiglightBig03'];

    static readonly SCATTER_LAND_1: string = 'scatterLand1';
    static readonly SCATTER_LAND_2: string = 'scatterLand2';
    static readonly SCATTER_LAND_3: string = 'scatterLand3';
    static readonly SCATTER_LAND_FAIL: string = 'scatter3Fail';
    static readonly SCATTER_LAND_FALL: string = 'scatter3Fall';

    static readonly SW_ENABLED: string[] = ['wildEnable1', 'wildEnable2', 'wildEnable3'];
    static readonly SW_DISABLED: string = 'wildOff';
    static readonly SW_INDICATOR_BAR_1: string = 'wildCollect1';
    static readonly SW_INDICATOR_BAR_2: string = 'wildCollect2';
    static readonly SW_INDICATOR_BAR_3: string = 'wildCollect3';
    static readonly SW_INDICATOR_BAR_4: string = 'wildCollect4';
    static readonly SW_INDICATOR_BAR_5: string = 'wildCollect5';
    static readonly SW_INDICATOR_BAR_6: string = 'wildCollect6';
    static readonly SW_INDICATOR_BAR_7: string = 'wildCollect7';
    static readonly SW_INDICATOR_BAR_8: string = 'wildCollect8';
    static readonly SW_INDICATOR_BAR_9: string = 'wildCollect9';
    static readonly SW_INDICATOR_BAR_10: string = 'wildCollect10';
    static readonly SW_INDICATOR_BAR_11: string = 'wildCollect11';
    static readonly SW_INDICATOR_BAR_12: string = 'wildCollect12';
    static readonly SW_INDICATOR_BAR_13: string = 'wildCollect13';
    static readonly SW_INDICATOR_BAR_14: string = 'wildCollect14';
    static readonly SW_INDICATOR_BAR_15: string = 'wildCollect15';
    static readonly SW_INDICATOR_BAR_16: string = 'wildCollect16';
    static readonly SW_INDICATOR_BAR_17: string = 'wildCollect17';
    static readonly SW_INDICATOR_BAR_18: string = 'wildCollect18';
    static readonly SW_INDICATOR_BAR_RESET: string = 'wildReset';

    static readonly SHAKE_SYMBOLS: string = 'wildHint';
    static readonly WILD_SIZE_ACTIVE: string[] = ['wildActivate1', 'wildActivate2', 'wildActivate3'];
    static readonly WILD_SIZE_CHANT: string[] = ['wildActivateChant1', 'wildActivateChant2', 'wildActivateChant3'];
    static readonly WILD_FIRE_LOOP: string = 'wildFireLoop';

    static readonly MULTI_UP: string = 'multiplayerUp';
    static readonly CAPWIN_COUNTUP: string = 'capwinCountup';
    static readonly CAPWIN_LOOP: string = 'capwinLoop';

    static readonly GAME_AMBIANCE: string = 'background-music-main';

    static readonly REELS_QUICK_SPIN_START: string = 'spinStartGuitar1';

    static readonly REELS_SPIN_START: string[] = ['spinStart'];
    // static readonly REELS_SPINNING:string = "reelsSpinning";
    static readonly REELS_DEFAULT_STOP: string[] = ['reelLand01', 'reelLand02', 'reelLand03', 'reelLand04', 'reelLand05'];
    static readonly REELS_CUT_AVALANCHE: string[] = ['ropeCut01', 'ropeCut02', 'ropeCut03', 'ropeCut04', 'ropeCut05'];
    static readonly REELS_IN: string = 'reelsIn';
    static readonly REELS_OUT: string = 'reelsOut';

    static readonly ANTICIPATION_START: string = 'anticipation';
    static readonly ANTICIPATION_BIG: string = 'anticipationBig';
    static readonly ANTICIPATION_END: string = 'anticipationEnds';
    static readonly ANTICIPATION_PLING: string = 'anticipationBigEnds';
    static readonly SCATTER_LAND: string[] = ['scatter', 'scatter3', 'scatter4'];

    static readonly BETLINE_SHAKE: string = 'betlineShake';
    static readonly BETLINE_WIN: string = 'betline';
    static readonly BETLINE_WIN_ALL: string = 'betlineWin';
    static readonly NORMAL_TOTAL_WINS: string[] = ['winTiny', 'winSmall', 'winMedium', 'winLarge'];
    static readonly NORMAL_COUNTUP: string = 'countup';
    static readonly NORMAL_COUNTUP_END: string = 'countupEnds';

    static readonly RESPIN_INTRO: string = 'respinIntro';
    static readonly RESPIN_MUSIC: string = 'respinMusic';
}
